import styled from 'styled-components';
import { MobileModalContent, MobileModalLayout, ModalBackground, ModalFooter } from 'components/Modal/ModalForms';
import MobileBasicButton from 'components/Buttons/MobileBasicButton';
import { MouseEvent } from 'react';
import { Body1Bold } from 'styles/Global/typography';
import { ConfirmDialogueSimpleInfoModalProps } from 'models/Modal/confirmDialogTypes';

const ConfirmDialogueHorizonLeft = ({ clickFirstButton, clickSecondButton, title, content, firstButton, secondButton, counselData }: ConfirmDialogueSimpleInfoModalProps) => {
    const handleBackgroundClick = (e: MouseEvent) => {
        // 클릭된 요소가 배경 자체인 경우에만 닫기
        if (e.target === e.currentTarget) {
            clickFirstButton();
        }
    };

    return (
        <ModalBackground $type='mobile' onClick={handleBackgroundClick}>
            <MobileModalLayout $gap='20px' $maxWidth='360px'>
                <ModalTitleAndContentContainer>
                    <Title>{title}</Title>
                    <MobileModalContent>{content}</MobileModalContent>
                </ModalTitleAndContentContainer>
                <ModalFooter $marginTop='4px'>
                    <MobileBasicButton $width='100%' $height='52px' onClick={clickFirstButton} $type='gray'>
                        {firstButton}
                    </MobileBasicButton>
                    <MobileBasicButton $width='100%' $height='52px' onClick={clickSecondButton} $type='warning'>
                        {secondButton}
                    </MobileBasicButton>
                </ModalFooter>
            </MobileModalLayout>
        </ModalBackground>
    );
};

export default ConfirmDialogueHorizonLeft;

const ModalTitleAndContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 10px;
`;

const Title = styled(Body1Bold)``;
